<div class="raptor-page-container" [formGroup]="form">
  <open-raptor-progress *ngIf="!(formData.settings && formData.settings.hide_progress_bar)" [progress]="formData.progress" [pages]="formData.total_pages"></open-raptor-progress>
  <open-raptor-banner-header *ngIf="formData.settings?.banners" [data]="formData.settings?.banners"></open-raptor-banner-header>
  <open-raptor-banner-header *ngIf="bannerHeaders" [data]="bannerHeaders"></open-raptor-banner-header>
  <div class="grid">
    <div class="cell margin-right-medium margin-left-xmedium progress-nav">
      <button mat-icon-button color="primary" type="button" (click)="raptorFormService.reset()" [disabled]="raptorStepService.loading"><mat-icon>west</mat-icon></button>
    </div>
  </div>

  <div class="raptor-page-content padding-bottom-xxbig">
    <div class="raptor-page-panel" [class]="raptorStepService.action" *ngIf="raptorStepService.stepReady">

      <div class="grid">
        <div class="raptor-page-main-panel cell cell-small-col-span-6 cell-large-col-span-12">
          <header class="padding-horizontal-medium">
            <h1 class="text-center" [ngClass]="{'margin-bottom-medium': formData.subtext}" *ngIf="formData.heading">{{ formData.heading }}</h1>
            <p class="text-center margin-bottom-none" *ngIf="formData.subtext">
              <mat-icon>pin_drop</mat-icon>
              {{ formData.subtext }}
            </p>
          </header>

          <div class="flex flex-justify-center margin-horizontal-medium" id="rich-rating-badge-container">
            <div [id]="ratingId"></div>
          </div>

          <div class="grid grid-wrapper margin-top-xmedium" *ngIf="formData.data.cover_type === 'comp' && formData.data.kms_estimated <= 15000">
            <div class="cell cell-large-col-span-8 cell-medium-col-span-8 cell-small-col-span-8 cell-large-col-start-3">
              <mat-button-toggle-group [(ngModel)]="coverLevel" [ngModelOptions]="{standalone: true}" (change)="filterCovers()" class="cover-select">
                <mat-button-toggle value="payd"><div class="padding-xsmall"><span>Pay As You Drive</span><br><span class="text-xsmall">Cover for the kilometres you need</span></div></mat-button-toggle>
                <mat-button-toggle value="comp"><div class="padding-xsmall"><span>Unlimited Kilometres</span><br><span class="text-xsmall">Cover for unlimited kilometres</span></div></mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          
          <ng-container *ngIf="componentQuestions.length > 0 && formData.sections[0].settings.align === 'top'">
            <div class="grid grid-wrapper margin-vertical-xxsmall">
              <div class="cell cell-large-col-span-8 cell-medium-col-span-10 cell-small-col-span-6 cell-large-col-start-3 cell-medium-col-start-1">
                <div class="flex flex-wrap raptor-page-price-frequency margin-bottom-medium flex-justify-center">
                  <ng-container *ngFor="let row of componentQuestions">
                    <ng-container *ngFor="let element of row">
                      <open-raptor-question class="raptor-page-covers-component" [question]="element" [form]="form" [submitted]="true"></open-raptor-question>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
          
          <!-- MAIN CONTENT -->
          <div class="raptor-page-price-container grid">
            <div *ngFor="let cover of covers; let i = index"
              class="raptor-page-price-panel cell cell-small-col-span-6 cell-medium-col-span-6 cell-medium-col-start-2"
              [ngClass]="{
                'cell-large-col-span-6 cell-large-col-start-4': covers.length && covers.length === 1,
                'cell-large-col-span-5': covers.length && covers.length === 2,
                'cell-large-col-start-2': covers.length && covers.length === 2 && i === 0
              }"
            >
              <div class="raptor-page-price-content flex flex-column" [ngClass]="{'featured': cover.is_featured, 'active': cover.cover.product_slug === formData.data.product_slug && cover.cover.cover_type === formData.data.cover_type && cover.cover.cover_level === formData.data.cover_level}">
                <mat-icon class="raptor-page-price-selected-icon" *ngIf="cover.cover.product_slug === formData.data.product_slug && cover.cover.cover_type === formData.data.cover_type && cover.cover.cover_level === formData.data.cover_level">check_circle</mat-icon>
                <h3 class="raptor-page-price-cover-name">{{ cover.label }}</h3>
                <div class="text-small flex-grow" *ngIf="getCoverInfo(cover, 'description')">{{ getCoverInfo(cover, 'description') }}</div>

                <div *ngIf="cover.banner" class="raptor-page-price-banner-box margin-top-xsmall">
                  <div *ngFor="let banner of cover.banner">
                    <div *ngIf="banner.tag" class="margin-bottom-xsmall raptor-page-price-banner">
                      {{ getTagLabel(banner) }}
                    </div>
                  </div>
                </div>

                <div class="text-left width-full" *ngIf="raptorStepService.updating">
                  <div *ngIf="raptorStepService.updating" class="padding-top-small margin-bottom-small">
                    <mat-spinner diameter="50" class="price-spinner"></mat-spinner>
                  </div>
                </div>

                <div class="text-left width-full" *ngIf="!raptorStepService.updating">
                  <div class="h4-subheading margin-top-xxsmall margin-bottom-none" id="additional-charges-monthly-heading" *ngIf="cover.has_additional_charges && cover.additionalChargesBanners && frequency === 'M'">{{ getPolicyArrangementMonthlyHeading(cover) }}</div>
                  <div class="raptor-page-price-discount margin-bottom-xxsmall" *ngIf="(raptorPriceService.getCoverDiscount(cover, frequency, currency, currencySymbol) | keyvalue)?.length">WAS 
                    <open-price [price]="raptorPriceService.getCoverDiscount(cover, frequency, currency, currencySymbol)" [precision]="2" size="small"></open-price>
                  </div>
                  <div>
                    <open-price [price]="raptorPriceService.getCoverPrice(cover, frequency, currencySymbol)" [precision]="0" class="margin-bottom-small" size="large" [ngClass]="{ 'margin-top-small': !cover.has_additional_charges }"></open-price>
                  </div>
                  <div class="text-small" *ngIf="cover.has_additional_charges && cover.additionalChargesBanners" [ngClass]="{ 'featured': cover.is_featured }" [innerHTML]="frequency === 'M' ? cover.additionalChargesBanners.tag.monthly : cover.additionalChargesBanners.tag.annual"></div>
                  <div class="text-small" *ngIf="!cover.has_additional_charges">Including GST and Government charges</div>
                  <div class="text-small" *ngIf="frequency !== 'U'">
                    Totals <open-price [price]="raptorPriceService.getYearlyCoverPrice(cover, currencySymbol)" [precision]="0" class="margin-bottom-small" size="xsmall"></open-price>
                  </div>
                </div>

                <div class="page-price-select-cover margin-bottom-medium width-full">
                  <button mat-flat-button color="primary" type="button" class="width-full" (click)="selectCover(cover)" [disabled]="raptorStepService.loading">
                    <span class="mdc-button__label" *ngIf="!raptorStepService.loading">Select</span>
                    <mat-spinner *ngIf="raptorStepService.loading" diameter="28"></mat-spinner>
                  </button>
                </div>

                <div class="raptor-page-price-features width-full text-left margin-bottom-small">
                  <ul>
                    <li *ngFor="let feature of getCoverFeatures(cover)">
                      <mat-icon [ngClass]="feature.is_optional_feature ? 'optional' : ''">
                        {{ feature.is_optional_feature ? 'add_circle' : 'check_circle'}}
                      </mat-icon>
                      <span>{{ feature.text }}</span>
                    </li>
                  </ul>
                </div>
                <div class="raptor-page-price-pds width-full">
                  <open-tooltip
                    *ngIf="getCoverInfo(cover, 'covered_help')"
                    [tooltipContent]="getCoverInfo(cover, 'covered_help').text"
                    [tooltipType]="'link'"
                    [tooltipLabel]="'See what\'s covered'"
                  ></open-tooltip>
                </div>
              </div>
            </div>
          </div>

          <div class="grid grid-wrapper margin-vertical-xxsmall" *ngIf="formData.cover_exclusions_info && formData.cover_exclusions_info.length">
            <div class="cell cell-large-col-span-10 cell-medium-col-span-6 cell-small-col-span-6 cell-large-col-start-2 cell-medium-col-start-2">
              <div class="open-form-info radius-ai padding-medium">
                <div *ngFor="let info of formData.cover_exclusions_info">
                  <b *ngIf="info.heading" class="margin-bottom-xsmall">{{ info.heading }}</b>
                  <p *ngIf="info.content">{{ info.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <input type="hidden" formControlName="cover_level" id="cover_level" />
    <input type="hidden" formControlName="cover_type" id="cover_type" />
    <input type="hidden" formControlName="product_slug" id="product_slug" />
    <button type="submit" hidden id="coverSubmit">submit</button>

  </div>

  <div class="raptor-prices-reviews padding-bottom-xbig" *ngIf="formData.settings.reviews && formData.settings.reviews.length">
    <div class="padding-horizontal-medium padding-top-xlarge raptor-prices-review">
      <h2 class="text-center margin-bottom-xmedium">Here&apos;s what our customers have to say</h2>
      <div class="grid">
        <div *ngFor="let review of formData.settings.reviews" class="raptor-prices-review-panel cell cell-small-col-span-6 cell-medium-col-span-6 cell-medium-col-start-2 cell-large-col-span-4">
          <div class="flex flex-column">
            <div>
              <span *ngFor="let star of stars; let i = index;" class="inline-block margin-bottom-xsmall">
                <svg *ngIf="i < review.stars" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.15703 22L8.48203 14.4L2.33203 10H9.93203L12.332 2L14.732 10H22.332L16.182 14.4L18.507 22L12.332 17.3L6.15703 22Z" fill="#0B793D"/>
                </svg>    
              </span>
            </div>
            <h4 class="margin-bottom-small">{{ review.title }}</h4>
            <p class="flex-grow" [innerHTML]="review.text"></p>
            <p>{{ review.author }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="raptor-prices-marketing raptor-page-panel bg-secondary" [class]="raptorStepService.action" [ngClass]="{ 'no-reviews': !(formData.settings.reviews && formData.settings.reviews.length) }" *ngIf="!raptorStepService.loading && formData.settings && formData.settings.marketing && formData.settings.marketing[coverLevel || 'default']">
    <div class="grid text-center padding-horizontal-medium padding-vertical-xbig">
      <div class="cell cell-small-col-span-6 cell-large-col-span-12">
        <h2 class="margin-bottom-small">{{ formData.settings.marketing[coverLevel || 'default'].heading }}</h2>
        <p class="margin-bottom-small">{{ formData.settings.marketing[coverLevel || 'default'].sub_text }}</p>

        <div class="grid margin-bottom-large" *ngIf="formData.settings.marketing[coverLevel || 'default'].content.length">
          <div class="cell cell-large-col-span-4 cell-medium-col-span-6 cell-small-col-span-6 cell-medium-col-start-2 padding-top-medium" *ngFor="let item of formData.settings.marketing[coverLevel || 'default'].content">
            <open-svg-icon [name]="item.icon" class="medium"></open-svg-icon>
            <h4 class="margin-vertical-small">{{ item.text }}</h4>
            <div class="text-small">{{ item.sub_text }}</div>
          </div>
        </div>

        <p class="padding-top-medium text-xsmall" *ngIf="formData.settings.marketing[coverLevel || 'default'].footer" [innerHTML]="formData.settings.marketing[coverLevel || 'default'].footer"></p>
      </div>
    </div>
  </div>
</div>

<!-- Cover disclaimers -->
<div class="grid grid-wrapper mat-typography margin-top-medium" *ngIf="!raptorStepService.loading && disclaimers">
  <div class="cell cell-small-col-span-6 cell-large-col-span-12">
    <div *ngFor="let disclaimer of disclaimers | orderBy: 'type': 'desc'; index as i">
      <div *ngIf="disclaimer.type === 'promotional'" class="raptor-page-price-banner-disclaimer text-xsmall" [ngClass]="{'margin-bottom-xsmall':i < disclaimers.length - 1}">
        {{ disclaimer.content }}
      </div>
      <div *ngIf="disclaimer.type === 'banner'" class="raptor-page-price-banner-disclaimer text-xsmall" [ngClass]="{'margin-bottom-xsmall':i < disclaimers.length - 1}" [innerHTML]="disclaimer.content">
      </div>
      <!-- Showing extras banners at the bottom in order to list the included extras disclaimers that accompany this specific disclaimer -->
      <div *ngIf="disclaimer.type === 'additionalCharges'" class="raptor-page-price-banner-disclaimer text-xsmall" [ngClass]="{'margin-bottom-xsmall':i < disclaimers.length - 1}">
        {{ disclaimer.content }}
      </div>
    </div>
    <ul class="margin-bottom-none" *ngIf="includedExtrasDisclaimers?.length">
      <li class="raptor-page-price-banner-disclaimer text-xsmall" *ngFor="let extrasDisclaimer of includedExtrasDisclaimers"><strong>{{ extrasDisclaimer.label }}:</strong> {{ extrasDisclaimer.disclaimer }}</li>
    </ul>
  </div>
</div>

<!-- Page disclaimer -->
<div class="grid grid-wrapper mat-typography margin-top-medium" *ngIf="!raptorStepService.loading && formData.disclaimer && formData.disclaimer.content">
  <div class="cell cell-small-col-span-6 cell-large-col-span-12">
    <p class="raptor-page-price-banner-disclaimer margin-bottom-none text-xsmall" [innerHTML]="formData.disclaimer.content"></p>
  </div>
</div>
